import { Controller } from "stimulus"

import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
Chart.register(ChartDataLabels);

export default class extends Controller {
  static targets = ["chartElement"];

  buildChart(json) {
    //var chart_element = this.chartElementTarget; // Have no idea why ChartJs doesn't like a stimulus target?!
    var chart_element = document.getElementById('monthly_result_chart'); // For some reason we have to retreive the element like this

    const money = new Intl.NumberFormat('sv-SE', {
      style: 'currency',
      currency: 'SEK',
      // These options are needed to round to whole numbers if that's what you want.
      minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });

    const results_per_month = json.map(row => Number(row.result));
    const accumulated = json.map(row => Number(row.accumulated));

    new Chart(
      chart_element,
      {
        data: {
          labels: json.map(row => row.month_start),
          datasets: [
            {
              type: 'line',
              label: 'Ackumulerat', 
              data: accumulated,
              //tension: 0.2, // If we want a softened curve
              pointRadius: 7,
              pointBorderWidth: 3,
              pointBackgroundColor: '#FFFFFF',
              pointHoverRadius: 10,
              pointHoverBorderWidth: 3,
              pointHoverBackgroundColor: '#FFFFFF',
              borderColor: '#54cf47',
              backgroundColor: '#FFFFFF',
              datalabels: {
                formatter: function(value, context) {
                  // console.log(context.datasetIndex);
                  // console.log(context.dataIndex);
                  // console.log(context.chart.data.datasets[0].data.length);
                  return context.dataIndex == context.chart.data.datasets[0].data.length-1 ? money.format(value) : '';
                },
                color: '#666',
              }
            },
            {
              type: 'bar',
              label: 'Månadens netto', 
              data: results_per_month,
              backgroundColor: '#fee884',
              datalabels: {
                olor: '#666',
              },
            },
          ]
        },
        options: {
          maintainAspectRatio: false,
          scales: {
            x: {
              stacked: true
            },
            y: {
              stacked: true,
              max: (Math.trunc(accumulated.max()*1.1 / 20000)+1) * 20000
            }
          },
          plugins: {
            datalabels: {
              align: 'end',
              anchor: 'end',
              // color: function(context) {
              //   return context.dataset.backgroundColor;
              // },
              font: function(context) {
                var w = context.chart.width;
                return {
                  size: w < 512 ? 12 : 14,
                  weight: 'bold',
                };
              },
              formatter: function(value, context) {
                return money.format(value);
              }
            }
          }
        }
      }
    );
  }

  connect() {
    var chart_element = this.chartElementTarget;

    var chartRequest = new Request.JSON({
      url: '/bank_accounts/monthly_result',
      method: 'get',
      onRequest: function() {
        return chart_element.addClass('loading');
      },
      onSuccess: this.buildChart
    });

    chartRequest.send();
  }
}